require('scss/app.scss');

// libs
require('css/libs/font-awesome.css');
require('css/libs/nanoscroller.css');
require('css/libs/fullcalendar.css');
require('css/libs/calendar.css');
require('css/libs/daterangepicker.css');
require('css/libs/jquery-jvectormap-1.2.2.css');
require('css/libs/dataTables.bootstrap.css');

require('ladda/css/ladda.scss');

// global styles
require('scss/theme_styles.scss');



// WEBPACK FOOTER //
// ./assets.js